import React from 'react';
import styled, { css } from 'styled-components';
import { colors, neumorphism } from './constant';

import ToggleableButton from './ToggleableButton';

const SortButton = ({ nowSortKey, setSortKey, nowSortMethod, setSortMethod, children, className, sortKey }) => {
    
    const handleClick = v => {

        if (nowSortKey !== sortKey) {
            setSortKey(sortKey);
            setSortMethod('desc');
        }
        else if (nowSortKey === sortKey && nowSortMethod === 'desc') {
            setSortMethod('asc');
        }
        else if (nowSortKey === sortKey && nowSortMethod === 'asc') {
            setSortKey(null);
            setSortMethod(null);
        }
    }

    const sortSelected = nowSortKey === sortKey;
    const isAsc = nowSortMethod === 'asc';

    return (
        <Button as={ToggleableButton} className={className} value={sortSelected} setValue={handleClick}>
            { children }
            <Svg width="1em" height="1em" viewBox="-2 -5 18 14" sortSelected={sortSelected} isAsc={isAsc}>
                <path d="M6.09173 8.6208L0.301065 2.00186C-0.382321 1.22309 0.173081 4.43966e-07 1.21023 4.43966e-07H12.7916C13.0237 -0.000198568 13.2509 0.0665128 13.4461 0.192146C13.6413 0.317779 13.7961 0.497009 13.892 0.70837C13.988 0.919732 14.021 1.15427 13.987 1.38389C13.9531 1.61351 13.8537 1.82849 13.7007 2.00307L7.91007 8.61959C7.79674 8.74928 7.65698 8.85322 7.50017 8.92444C7.34336 8.99565 7.17313 9.0325 7.0009 9.0325C6.82868 9.0325 6.65844 8.99565 6.50163 8.92444C6.34482 8.85322 6.20506 8.74928 6.09173 8.61959V8.6208Z" fill="currentColor"/>
                <line x1="1" y1="4" x2="13" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </Svg>
        </Button>
    )
}

const Svg = styled.svg`
    margin-left: 12px;

    >path, >line {
        transition: all .2s;
    }

    >line {
        opacity: 1;
        transform: translateY(-3px);
    }

    ${({sortSelected}) => !sortSelected && css`
        >path {
            transform: scaleY(0);
            opacity: 0;
        }
        >line {
            opacity: 1;
            transform: translateY(0px);
        }
    `}

    ${({sortSelected, isAsc}) => (sortSelected && isAsc) && css`
        >path {
            transform: rotateX(180deg) translateY(-50%) translateY(-2px);
        }
        >line {
            opacity: 0;
        }
    `}
`

const Button = styled.button`

`

export default SortButton;
